import React, { useState, useRef, useEffect } from "react";
import "./Reels.css";
import FuzzyText from "./FuzzyText";

import dp from "../assets/reels/dp.mp4";
import dpp from "../assets/reels/dpp.mp4";
import a from "../assets/reels/a.mp4";
import b from "../assets/reels/b.mp4";
import c from "../assets/reels/c.mp4";

// Posters extraídos con FFmpeg (o cualquier editor)
import dpPoster from "../assets/reels/dpcap.png";
import dppPoster from "../assets/reels/cap2.png";
import caPoster from "../assets/reels/ca.png";
import ddPoster from "../assets/reels/dd.png";
import dpcapPoster from "../assets/reels/dpcap.png";

// ⭐ WebM optimizado como fondo
import fondoVideo from "../assets/fondorop.webm";

const Reels = () => {
  const reels = [
    { video: dp, poster: dpPoster },
    { video: dpp, poster: dppPoster },
    { video: c, poster: ddPoster },
    { video: a, poster: caPoster },
    { video: b, poster: dpcapPoster },
    
  ];

  const [selected, setSelected] = useState(null);
  const videoRefs = useRef([]);
  const bgVideoRef = useRef(null);

  // ⭐ AUTOPLAY FIX PARA MOBILE
  useEffect(() => {
    const v = bgVideoRef.current;
    if (!v) return;

    const tryPlay = () => {
      v.play().catch(() => {});
    };

    v.addEventListener("loadeddata", tryPlay);

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        v.play().catch(() => {});
      }
    };
    document.addEventListener("visibilitychange", onVisibility);

    const unlock = () => {
      v.play().catch(() => {});
      window.removeEventListener("touchstart", unlock);
    };
    window.addEventListener("touchstart", unlock);

    return () => {
      v.removeEventListener("loadeddata", tryPlay);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("touchstart", unlock);
    };
  }, []);

  const handleMouseEnter = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      video.play().catch((err) =>
        console.warn("Video play interrupted:", err)
      );
    }
  };

  const handleMouseLeave = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      video.pause();
    }
  };

  return (
    <section className="section reels" id="reels">
      {/* ⭐ FONDO AHORA 100% COMPATIBLE */}
      <video
        ref={bgVideoRef}
        className="cover-video"
        autoPlay
        loop
        muted
        playsInline
        webkitPlaysInline={true} // ← FIX REACT / iOS
      >
        <source src={fondoVideo} type="video/webm" />
        Tu navegador no soporta videos de fondo
      </video>

      <div className="section-header">
        <FuzzyText
          fontSize="clamp(3rem, 8vw, 6rem)"
          fontWeight={900}
          color="#ffffffff"
          fontFamily="Akira Expanded"
        >
          Shorts
        </FuzzyText>
        <p>Arte visual creado para artistas y marcas.</p>
      </div>

      <div className="reels-grid">
        {reels.map((r, i) => (
          <div
            key={i}
            className="reel-card"
            onClick={() => setSelected(r.video)}
          >
            <video
              ref={(el) => (videoRefs.current[i] = el)}
              src={r.video}
              muted
              loop
              playsInline
              preload="metadata"
              poster={r.poster} // ← ahora sí se ve la portada
              onMouseEnter={() => handleMouseEnter(i)}
              onMouseLeave={() => handleMouseLeave(i)}
            />
          </div>
        ))}
      </div>

      {selected && (
        <div className="reel-modal" onClick={() => setSelected(null)}>
          <div
            className="reel-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={selected}
              controls
              autoPlay
              muted
              loop
              className="reel-video"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Reels;
